import React,{useEffect, useState} from 'react'
import WebsiteListingPage from './WebsiteListingPage'
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import MessageWindowForTrackWebsite from './MessageWindowForTrackWebsite';
import axios from 'axios';
import { newSourceUrl } from '../../../../api/Source.api';
import TrackWebsiteModal from './TrackWebsiteModal';

const WebTrackHome = () => {
    const {iswebTrackClicked,currentWebsiteLinkedId, updateWebList,setUpdateWebList,currentWebs,setCurrentWebs, refetchClicked,setRefetchClicked,setWebTrackingWebsiteLoading} = useWorkspace();
    const token = localStorage.getItem('token');
    // const [currentWebs,setCurrentWebs] = useState([]);
    const [addWebClicked, setAddWebClicked] = useState(false);
    // const [refetchClicked,setRefetchClicked] = useState(false);
    // const [updateWebList,setUpdateWebList] = useState(false);

    const handleUpdateList = () => {
      setUpdateWebList(!updateWebList);
    };

    useEffect(() => {
      fetchWebsites();
    }, [addWebClicked,updateWebList,currentWebsiteLinkedId]);

    const handleAddWebClicked = () => {
      setAddWebClicked(!addWebClicked);
    };

    const handleRefetchClicked = () => {
      setRefetchClicked(!refetchClicked);
    };
  
    const fetchWebsites = async () => {
      setWebTrackingWebsiteLoading(true);
      try {
        const res = await axios.get(`${newSourceUrl}/v1/websiteTrackings/listAll`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Map backend response to frontend structure
        const mappedData = res?.data?.data?.map(item => ({
          ...item,
          websiteId: item.id, // Map id to websiteId for backward compatibility
          websiteLink: item.website_link,
          displayName: item.display_name,
          frequencyInMins: item.frequency_in_mins,
          isDisabled: item.is_disabled,
          isDefault: item.is_default,
          addedAt: item.added_at,
          orderInList: item.order_in_list,
          lastViewed: item.last_viewed,
          notificationCount: item.notification_count,
          createdAt: item.created_at
        })) || [];

        const sortedData = mappedData.sort((a, b) => {
          // Step 1: Prioritize websites with `notificationCount > 0`
          const aHasNotifications = a.notificationCount > 0;
          const bHasNotifications = b.notificationCount > 0;

          if (aHasNotifications !== bHasNotifications) {
            return bHasNotifications - aHasNotifications; // Websites with notifications > 0 come first
          }

          // Step 2: Among websites with the same notification status, sort by `addedAt` (most recent first)
          return new Date(b.addedAt) - new Date(a.addedAt);
        });

        setCurrentWebs(sortedData);
        setWebTrackingWebsiteLoading(false);
      } catch (error) {
        console.error(error);
        setWebTrackingWebsiteLoading(false);
      }
    };

  return (
    <div>
      <WebsiteListingPage website={currentWebs} updateWebList={handleUpdateList} />
     {/* { currentWebsiteLinkedId ? <MessageWindowForTrackWebsite website={currentWebs} onHandleRefetch={handleRefetchClicked} refetchClicked={refetchClicked} updateWebList={handleUpdateList} /> : <WebsiteListingPage website={currentWebs} updateWebList={handleUpdateList} />} */}
        <TrackWebsiteModal
          onAddWebClicked={handleAddWebClicked}
        />
    </div>
  )
}

export default WebTrackHome